import React from 'react';
import Layout from './component/layout';

// Wraps every page in the shared Layout (nav, footer, loader). This replaces
// the `layout` option that gatsby-plugin-transition-link used to provide.
// The keyed `.page-fade` wrapper re-mounts on each navigation so the CSS
// fade-in animation retriggers, reproducing the old AniLink `fade` effect
// without the unmaintained plugin.
export const wrapPageElement = ({ element, props }) => {
  return (
    <Layout>
      <div key={props.location.pathname} className="page-fade">
        {element}
      </div>
    </Layout>
  );
};
